// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"162d750d","239":"3edd8e6f","453":"d0ddb82f","732":"058bf6b2"}[chunkId] + ".chunk.js";
};